import {useRef} from 'react';

import {componentSpan as trackComponentSpan} from './../../services/analytics';

type UseMeasureComponentConfig = {
  singleUse?: boolean;
};

/**
 * This is made to measure the time between when a component mounts, and some
 * subsequent event within the lifecycle of that component (or its children, as
 * the measure function can be passed down}. The `singleUse` option is aimed at
 * making sure the track call isn't accidentally spammed during prop refeshes.
 */
export function useMeasureComponentSpan(
  name: string,
  {singleUse = true}: UseMeasureComponentConfig
) {
  const mount = useRef(performance.now()); // establish a timestamp for component mount
  const hasFired = useRef(false);

  function measure(logData?: Record<string, any>) {
    const now = performance.now();
    const duration = now - mount.current;

    // eject on any subsequent triggers of the measure call if only doing a single span
    if (hasFired.current && singleUse) {
      return;
    }
    trackComponentSpan({
      ...logData,
      duration: Math.ceil(duration),
      spanName: name,
      startTime: mount.current,
      stopTime: now,
    });
    hasFired.current = true;
  }

  return measure;
}
